<template>
  <div v-bind:class="{ 'op--modal-container': true, hide: !show }" @click="close">
    <div class="op--modal">

      <div class="op--modal-content">
        <div class="flight-box" @click.stop>
          <div v-show="!showFlightList">
            <div class="title">{{ $t('serviceSelect.chooseAirline') }}</div>
            <div class="field-group">
              <input class="field-text" type="text" v-model="airlineSearch"
                :placeholder="$t('serviceSelect.search')" @keyup="filterAirlines" ref="airline" />
            </div>
            <ul class="suggestions">
              <li v-for="(item, index) in airlines" @click="selectAirline(item)">
                <i class="fas fa-plane"></i>
                <span>{{ item.label }}</span>
              </li>
            </ul>
            <div class="modal-cancel margin-t-s">
              <span @click="close">{{ $t('common.cancel') }}</span>
            </div>
          </div>

          <div v-show="showFlightList">
            <div class="title">
              <i class="fas fa-chevron-left" @click="showFlightList = false"></i>
              {{ $t('serviceSelect.chooseFlight') }}
            </div>

            <transition name="slide-up">
              <div class="flight-error-msg margin-b-xs"
                v-if="!!flightErrorMsg">{{ flightErrorMsg }}</div>
            </transition>

            <div class="field-group">
              <input class="field-text" type="text" v-model="flightSearch"
                :placeholder="flightPlaceholder" @keyup="filterFlights"
                ref="flight" :disabled="flightLoading" />
            </div>

            <transition name="slide-up">
              <div v-show="enableCustomFlight && !flightLoading">
                <label class="flight-intl">
                  <input type="checkbox" v-model="isDomestic"/>
                  {{ $t('serviceSelect.thisDomestic') }}
                </label>
                <a class="op-btn btn-block btn-success margin-b-s" @click="setCustomFlight">{{ $t('common.submit') }}</a>
              </div>
            </transition>

            <div class="flight-loader" v-show="flightLoading">
              <i class="fas fa-spinner fa-spin"></i>
            </div>

            <ul class="suggestions flight-list"
              v-show="!enableCustomFlight && !flightLoading && flights.length">
              <li v-if="!flightLoading && flights.length" class="custom-flight">
                <a @click="customFlight">{{ $t('serviceSelect.cantFindFlight') }}</a>
              </li>
              <li v-for="(item, index) in flights" @click="selectFlight(item)">
                <i class="fas fa-plane"></i>
                <div>
                  <span><b>{{item.label}}</b></span>
                  <small v-if="item.fromTo" v-html="item.fromTo"></small>
                </div>
              </li>
            </ul>

            <div class="modal-cancel margin-t-s">
              <span @click="close">{{ $t('common.cancel') }}</span>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ApiQuote from '@/modules/api/quote'
import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'flight-modal',
  props: ['leg'],
  data () {
    return {
      airlines: [],
      airlineSearch: '',
      flights: [],
      flightSearch: '',
      showFlightList: false,
      flightLoading: false,
      enableCustomFlight: false,
      flightErrorMsg: '',
      lastFlightDate: '',
      selectedAirline: {},
      isDomestic: true
    }
  },
  computed: {
    show () {
      let self = this
      let show = self.$store.state.reservation.showFlightModal
      self.flightErrorMsg = ''
      self.filterAirlines()
      if (show) { self.$nextTick(function () { self.$refs.airline.focus() }) }
      return show
    },
    geofenceId () { return this.$store.state.reservation.airlineGID },
    airlineList () { return this.$store.state.reservation.airlineList },
    flightList () {
      if (!this.leg) { return [] }
      return this.$store.state.reservation.flightList[this.leg]
    },
    _flightLoading () { return this.$store.state.reservation.flightLoading },
    flightPlaceholder () {
      if ((!this.flightLoading && this.flights.length === 0) ||
        this.enableCustomFlight
      ) {
        return this.$t('serviceSelect.typeFlight')
      }

      return this.$t('serviceSelect.search')
    },
    mtech () { return this.$store.state.reservation.mtech }
  },
  methods: {
    close () {
      this.$store.commit('reservation/setShowFlightModal', false)
      this.showFlightList = false
      this.enableCustomFlight = false
    },
    filterAirlines () {
      let self = this
      let regex = new RegExp('^' + self.airlineSearch, 'i')
      let result = []
      let list = self.airlineList

      for (let i = 0; i < list.length; i++) {
        if (!regex.test(list[i].name)) { continue }
        result.push(list[i])
      }
      self.airlines = result
    },
    filterFlights () {
      let self = this
      let regex = new RegExp('^' + self.flightSearch, 'i')
      let result = []
      let list = self.flightList
      if (self.flightList[self.leg]) {
        list = self.flightList[self.leg]
      }

      if (!self.flightList.length) { return }
      if (!list.length) { return } // Manual

      for (let i = 0; i < list.length; i++) {
        if (!regex.test(list[i].code)) { continue }
        result.push(list[i])
      }
      self.flights = result
    },
    selectAirline (item) {
      let self = this
      self.selectedAirline = {
        leg: self.leg,
        airline: item.name,
        airlineCode: item.code
      }

      self.showFlightList = true
      self.getFlightList()
    },
    getFlightList () {
      let self = this
      let rsvp = self.$store.state.reservation

      let airportCode = rsvp[self.leg].airportCode
      let airlineCode = self.selectedAirline.airlineCode
      let date = moment()
      if (rsvp[self.leg].flightDate) {
        date = moment(rsvp[self.leg].flightDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
      }
      if (rsvp[self.leg].isAirportDropoff && !rsvp[self.leg].isAirportPickup && rsvp[self.leg].isAsap) {
        date = date.add(self.$settings.get('DepartureDomesticBuffer'), 'minutes')
      }
      let sdkUrl = ''

      if (airlineCode === null || airlineCode === '') {
        sdkUrl = '/availability/flights?airport=' + airportCode +
        '&date=' + date.format('YYYY-MM-DD') +
        '&time=' + date.format('HH:mm:ss')
      } else {
        sdkUrl = '/availability/flights?airport=' + airportCode +
        '&airline=' + airlineCode +
        '&date=' + date.format('YYYY-MM-DD') +
        '&time=' + date.format('HH:mm')
      }
      if (rsvp[self.leg].isAirportPickup) {
        sdkUrl += '&departure=0'
      } else if (rsvp[self.leg].isAirportDropoff) {
        sdkUrl += '&departure=1'
      }
      sdkUrl += '&adjust=0'

      if ((self.flightLoading || airlineCode === rsvp[self.leg].flightAID) &&
        self.lastFlightDate === date.format('YYYY-MM-DD HH:mm')
      ) {
        if (!rsvp.flightList[self.leg].length) { self.enableCustomFlight = true }
        return
      }

      self.lastFlightDate = date.format('YYYY-MM-DD HH:mm')

      self.flights = []
      self.$store.commit('reservation/setFlightList', {
        leg: self.leg,
        value: []
      })
      self.$store.commit('reservation/setFlightLoading', true)
      self.$store.commit('reservation/setFlightAID', {
        leg: self.leg,
        value: airlineCode
      })
      self.$sdk.get(self, sdkUrl, {}, res => {
        self.$store.commit('reservation/setFlightLoading', false)
        self.enableCustomFlight = false
        if (res.list) {
          let flights = []
          res.list.forEach(function (data) {
            let from = moment.tz(data.departure.time.unix, 'X', data.departure.time.timezone).format('MM/DD hh:mmA')
            let to = moment.tz(data.arrival.time.unix, 'X', data.arrival.time.timezone).format('MM/DD hh:mmA')
            let flightData = {
              code: data.flight.number,
              name: data.airline.code + ' ' + data.flight.number + ' ' +
                data.departure.airportCode + '-' + data.arrival.airportCode,
              label: `${data.airline.code} ${data.flight.number} - ${data.airline.name}`,
              fromTo: `${data.departure.airportCode} (${from}) <i class="fas fa-chevron-right margin-h-xs"></i> ${data.arrival.airportCode} (${to})`,
                // data.departure.airportCode + '-' + data.arrival.airportCode,
              isDomestic: data.isDomestic === 1
            }
            if (rsvp[self.leg].isAirportPickup) {
              // flightData.time = moment(data.arrival.time.unix, 'X', data.departure.time.timezone).format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
              flightData.time = moment(data.arrival.time.unix, 'X').tz(rsvp[self.leg].timezone || 'America/Los_Angeles').format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
            }
            if (!rsvp[self.leg].isAirportPickup || rsvp[self.leg].isAirportDropoff) {
              // flightData.time = moment(data.departure.time.unix, 'X', data.departure.time.timezone).format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
              flightData.time = moment(data.departure.time.unix, 'X').tz(rsvp[self.leg].timezone || 'America/Los_Angeles').format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
            }
            flights.push(flightData)
          })
          if (!res.list.length) { self.enableCustomFlight = true }

          self.$store.commit('reservation/setFlightList', {
            leg: self.leg,
            value: flights
          })
          self.flights = flights
        } else {
          self.enableCustomFlight = true
        }
      })
    },
    selectFlight (item) {
      this.$store.commit('reservation/setAirline', this.selectedAirline)
      this.$store.commit('reservation/setFlightNo', { leg: this.leg, value: item.code })

      let date = moment(item.time, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      date = date.add(5 - (date.format('mm') % 5), 'minutes').format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false))

      this.$store.commit('reservation/setSuggestedTime', { leg: this.leg, value: date })
      this.$store.commit('reservation/setSuggestedTimeIsDomestic', { leg: this.leg, value: item.isDomestic })

      if (this.mtech.enabled) {
        this.getMtechQuote()
      }
      this.close()

      if (CONFIG.Env == 'production' && window.gtag) { // eslint-disable-line
        gtag('event', `Flight Information`, { // eslint-disable-line
          value: `${this.selectedAirline} ${item.code}`
        })
      }
    },
    customFlight () {
      let self = this
      self.enableCustomFlight = true
      self.$nextTick(function () { self.$refs.flight.focus() })
    },
    setCustomFlight () {
      let self = this
      if (self.flightSearch.trim() === '') {
        self.flightErrorMsg = 'Please provide your flight no.'
        self.$nextTick(function () { self.$refs.flight.focus() })
        return
      }

      let date = moment(this.$store.state.reservation[this.leg].flightDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      // date = date.add(5 - (date.format('mm') % 5), 'minutes').format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      this.$store.commit('reservation/setSuggestedTime', { leg: this.leg, value: date })

      this.$store.commit('reservation/setAirline', this.selectedAirline)
      this.$store.commit('reservation/setFlightNo', { leg: this.leg, value: this.flightSearch })
      this.$store.commit('reservation/setSuggestedTimeIsDomestic', { leg: this.leg, value: this.isDomestic })

      if (this.leg === 'leg2') {
        this.$store.commit('reservation/setApplySuggestedLeg2', true)
      }

      if (this.mtech.enabled) {
        this.getMtechQuote()
      }
      this.close()

      if (CONFIG.Env == 'production' && window.gtag) { // eslint-disable-line
        gtag('event', `Flight Information`, { // eslint-disable-line
          value: `${this.selectedAirline} ${this.flightSearch}`
        })
      }
    },
    getMtechQuote () {
      let self = this

      let leg1 = this.$store.state.reservation.leg1

      let pickupDate = moment(leg1.flightDate, 'MM/DD/YYYY').format('YYYY-MM-DD hh:mmA')
      let quoteData = {
        leg: 'leg1',
        brandId: self.$store.state.brandId,
        pickupDate: pickupDate,
        pickup: leg1.pickup,
        dropoff: leg1.dropoff,
        asap: false,
        order: 'priority',
        useFlightDate: true
      }

      self.$store.commit('reservation/setServiceLoading', true)
      ApiQuote.getQuote2(self, quoteData, res => {
        self.$store.commit('reservation/setServiceLoading', false)

        if (leg1.selectedService && self.mtech.leg1.services[leg1.selectedService].pickupTimes &&
          self.mtech.leg1.services[leg1.selectedService].pickupTimes.length
        ) {
          self.$store.commit('reservation/setMtechLegData', {
            leg: 'leg1',
            fields: {
              pickupDate: moment(self.mtech.leg1.services[leg1.selectedService].pickupTimes[0].unix, 'X').tz(leg1.timezone).format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
            }
          })
        }

        if (self.mtech.enabled && leg1.selectedService) {
          self.getQuoteMtechService()
        }
      })
    },
    getQuoteMtechService () {
      let self = this
      let rsvpData = this.$store.state.reservation[this.leg]

      let pickupDate = rsvpData.flightDate || rsvpData.pickupDate
      pickupDate = pickupDate || moment().format('MM/DD/YYYY hh:mmA')
      pickupDate = moment(pickupDate, 'MM/DD/YYYY hh:mmA')
      let quoteData = {
        asap: false,
        brandId: self.$store.state.brandId,
        leg: 'leg1',
        pickupDate: pickupDate.format('YYYY-MM-DD'),
        pickupTime: pickupDate.format('HH:mm:ss'),
        pickup: rsvpData.pickup,
        dropoff: rsvpData.dropoff,
        order: 'priority',
        passengers: rsvpData.passenger,
        mtechServiceType: rsvpData.selectedService
      }
      quoteData.pickup.text = quoteData.pickup.title
      quoteData.dropoff.text = quoteData.dropoff.title
      if (rsvpData.flightDate) {
        quoteData.pickupTimestamp = moment.tz(rsvpData.flightDate, 'MM/DD/YYYY hh:mmA', rsvpData.timezone).format('X')
      } else {
        quoteData.pickupTimestamp = moment.tz(`${quoteData.pickupDate} ${quoteData.pickupTime}`, 'YYYY-MM-DD HH:mm', rsvpData.timezone).format('X')
      }

      self.$store.commit('reservation/setServiceLoading', true)
      let timeNow = moment()
      self.$sdk.post(self, '/quotation', quoteData, res => {
        self.sendQuoteTime(timeNow, moment(), res.quoteId, quoteData)
        self.$store.commit('reservation/setServiceLoading', false)
        if (!res.error) {
          self.$store.commit('reservation/setQuoteId', res.quoteId)
          if (res.mtech.services.length) {
            let mtech = res.mtech
            let mtechStore = self.$store.state.reservation.mtech
            let service = res.mtech.services[0]
            let price = service.price

            let hasDiscount = false
            let discountVal = 0
            let totalBeforeDc = 0
            let baseFare = price.amount
            service.price.breakdown.forEach(x => {
              if (x.description === 'Base rate') {
                baseFare = x.amount
              }
              if (x.description === 'Discount') {
                hasDiscount = true
                discountVal = x.amount
              }
              if (x.amount > 0) {
                totalBeforeDc += x.amount
              }
            })

            let addMarkup = 0
            if (mtech.markup.value) {
              addMarkup = mtechStore.markup.value
              if (mtech.markup.type === '%') {
                addMarkup = baseFare * (mtech.markup.value / 100)
              }
              addMarkup = parseFloat(addMarkup.toFixed(2))
            }

            self.$store.commit('reservation/setMtechNewPricing', {
              code: rsvpData.selectedService,
              val: {
                baseFare: baseFare,
                amount: price.amount,
                addMarkup: addMarkup,
                breakdown: price.breakdown,
                hasDiscount: hasDiscount,
                discountVal: Math.abs(discountVal),
                totalBeforeDc: totalBeforeDc
              }
            })
          }
          self.$nextTick().then(() => {
            self.$forceUpdate()
          })
        }
      }, '2.0')
    },
    sendQuoteTime (start, end, quoteId, param) {
      let self = this
      let store = self.$store.state
      let duration = end.diff(start, 'milliseconds') / 1000
      self.$sdk.opt('/quotation/time', {
        token: store.user.token,
        brandId: store.brandId,
        quotationId: quoteId,
        responseTime: duration,
        deviceType: 'ww',
        data: JSON.stringify(param)
      }, res => {
        if (res.error) console.log('ERROR quotation time')
      })
    }
  },
  watch: {
    airlineList: function (value) {
      this.airlines = value
    },
    _flightLoading: function (value) {
      let self = this
      self.flightLoading = value
      if (value) return

      self.$nextTick(function () { self.$refs.flight.focus() })
      if (self.flightList.length) {
        self.enableCustomFlight = false
      } else {
        self.enableCustomFlight = true
      }
    },
    show: function (value) {
      document.body.classList.remove('widget-no-scroll')
      if (value) {
        this.flights = this.flightList
        this.airlineSearch = ''
        document.body.className += 'widget-no-scroll ' + document.body.className
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container{
  overflow: auto;
  -webkit-overflow-scrolling:touch;
}

.modal-cancel{
  text-align:center;
  span{
    padding: 2px 5px;
    cursor: pointer;
    color:#aaa;

    &:hover{
      text-decoration:underline;
      color:#777;
    }
  }
}

.flight-box {
  background-color: #fff;
  max-width: 400px;
  margin: 10px auto;
  padding: 20px;
  border-radius: 3px;
  position: relative;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  overflow: hidden;

  .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 15px;
    line-height: 1;

    i{
      float: left;
      cursor: pointer;
    }
  }
}

.suggestions{
  width: 100%;
  max-height: 300px;
  min-height: 300px;
  z-index: 2;
  list-style: none;
  overflow: auto;
  padding: 0;
  margin: 0;
  border: 1px solid #eaeaea;
  text-align: left;

  li{
    background: #fcfcfc;
    padding:8px 10px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    border-bottom: 1px solid #eee;
    color: #333;
    display:flex;
    align-items: center;

    &:last-child{ border-bottom: none; }
    a{
      text-align: center;
      display: block;
    }
    i{
      margin-right: 5px;
      color: #b4bfc7;
    }
    span{ font-size:13px; }
    div{
      width: 100%;
      span{
        font-size: 14px;
        line-height: 1;
      }
      small{
        font-size: 13px;
        color: #888;
        display: block;
        line-height: 1;
        i{ margin: 0 5px; }
      }
    }
    p{
      text-align: center;
      font-style: italic;
      color: #bbb;
    }
    .fa-exclamation-triangle{ color: #e2c84a;}
    .fa-map-marker{ color: #ea5c5c;}
    &.custom-flight{
      background: transparent;
      // background: #0d79f2;
      // color: #fff!important;
      // cursor: hand;
      // font-weight: 600;
    }
    &:hover:not(.custom-flight){
      background: #0D79F2;
      *{
        color: #fff;
      }
    }
    &.empty{ cursor: default; }
  }
}

.empty-flight{
  padding: 15px;
  text-align: center;
  font-style: italic;

  .fa-stack{ margin-right: 5px; }
  .fa-ban{ color:#e65c3d; }
}

.flight-loader{
  width: 100%;
  padding: 25px 0;
  position: relative;

  .fa-spinner{
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -18px;
    margin-top: -18px;
    font-size: 28px;
  }
}

.flight-error-msg {
  text-align: center;
  background: #EB5837;
  color: #fff;
  padding: 2px 0;
  font-size: 14px;
}

.flight-intl {
  display: block;
  margin-bottom: 8px;
  color: #777;

  input {
    margin-right: 3px;
    vertical-align: -1px;
  }
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .35s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(8px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// FlightModal.vue?2fbcc28a